import { Link } from 'react-router-dom';

// API keys are requested and managed on the SleuthNet profile page.
export const API_KEYS_URL = 'https://sleuthnet.com/account?tab=api';

export const isExternal = (to) => /^https?:\/\//.test(to);

// Props for an MUI component acting as a link: external URLs open in a new
// tab, internal paths use the router.
export const linkProps = (to) => (isExternal(to)
  ? { component: 'a', href: to, target: '_blank', rel: 'noopener noreferrer' }
  : { component: Link, to });
